import { AppManager } from 'core';
import { action, computed, observable } from 'mobx';

import { clientStore } from 'apps/client/app';

import { UserQuery } from './gql';

export type CreditCard = {
  id: string;
  brand: string;
  country?: string;
  expMonth: number;
  expYear: number;
  lastDigits: string;
  isDefault: boolean;
  name?: string;
};

export class CollaboratorsManager<T> extends AppManager {
  @observable userQuery: any;

  @observable collaborators: any[] = [];

  constructor(parent: T, init: any, options: Object) {
    super(parent, init, options);
    this.userQuery = new UserQuery(this, {
      variables: {
        username: clientStore.signedInProfile.username.replace('@', ''),
      },
      fetchPolicy: 'network-only',
    });
  }

  @computed get loading() {
    return this.userQuery?.loading;
  }

  @action QueryCollaborators = async () => {
    this.userQuery.process((data: any) => {
      if (!data) return null;

      this.collaborators = data.user.profile.collaborators.map(
        (collaborator: any) => {
          const { username, fullName, avatar, imageFallbackChar } =
            collaborator.profile;

          return {
            username,
            fullName,
            avatar: avatar?.url,
            imageFallbackChar,
          };
        },
      );
    });

    this.userQuery.query();
  };
}
